import { apiFetch } from "./client";

export type SearchBookingHit = {
  id: number;
  buchungsreferenz: string;
  gruppenname: string;
  gastname: string;
  check_in: string;
  check_out: string;
  status: string;
  einheiten_namen: string[];
};

export type SearchInquiryHit = {
  id: number;
  gruppenname: string;
  kontakt: string;
  email: string;
  status: string;
  check_in: string;
  check_out: string;
};

export type SearchResults = {
  bookings: SearchBookingHit[];
  inquiries: SearchInquiryHit[];
};

export function search(q: string): Promise<SearchResults> {
  return apiFetch<SearchResults>(`/api/search?q=${encodeURIComponent(q)}`);
}
